export const PAGE_TITLE = "Audbility - Planos do usuário";

export const DATE_FORMAT = "DD/MM/YYYY";

export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm";

export const STATUS_STYLES = {
  red: {
    color: "#cf1322",
    background: "#fff1f0",
    border: "1px solid #ff4d4f",
  },
  cyan: {
    color: "#08979c",
    background: "#e6fffb",
    border: "1px solid #13c2c2",
  },
  gold: {
    color: "#d48806",
    background: "#fffbe6",
    border: "1px solid #faad14",
  },
  orange: {
    color: "#d46b08",
    background: "#fff7e6",
    border: "1px solid #fa8c16",
  },
  green: {
    color: "#389e0d",
    background: "#f6ffed",
    border: "1px solid #52c41a",
  },
  gray: {
    color: "#777777",
    background: "#f5f5f5",
    border: "1px solid #bdbdbd",
  },
};

export const AUDBILITY_STATUS_CONFIG = {
  pending_email_confirmation: { label: "Limbo", style: STATUS_STYLES.red },
  email_confirmed: { label: "Email confirmado", style: STATUS_STYLES.cyan },
  pending_approval_documentation: {
    label: "Doc em análise",
    style: STATUS_STYLES.gold,
  },
  rejected_documentation: {
    label: "Doc rejeitado",
    style: STATUS_STYLES.orange,
  },
  approved_documentation: { label: "Doc aprovado", style: STATUS_STYLES.cyan },
  approved: { label: "Ativo", style: STATUS_STYLES.green },
};

// Motivos de recusa enviados para a API
export const REJECTION_REASONS = {
  DOCUMENTO_INELEGIVEL: "DOCUMENTO_INELEGIVEL",
  TIPO_DOCUMENTO_INVALIDO: "TIPO_DOCUMENTO_INVALIDO",
  ARQUIVO_CORROMPIDO: "ARQUIVO_CORROMPIDO",
  DOCUMENTO_INVALIDO: "DOCUMENTO_INVALIDO",
};
